import {ClientUserReportModel} from '@spa/api';

import {
    ReportTableColumn,
    ReportTableActionsEnum,
    ReportTableConfigInterface,
    ReportTableButtonTypesEnum,
    ReportTableActionMenuTypesEnum
} from '../../app/shared/components/report-table';

export const PanelClientUsersEditTwoFactorDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Status',
            selector: ClientUserReportModel.getTwoFactorEnabledSelector()
        })
    ],
    hiddenColumnIds: [],
    disableColumnsOptions: true,
    actionMenu: true,
    actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
    actionMenuItems: [
        {
            buttonType: ReportTableButtonTypesEnum.Reset,
            action: ReportTableActionsEnum.Reset
        }
    ]
};
